module.exports = __webpack_public_path__ + "16affefff6061f41f4fa9a59db1add9d.png";